import { FormikProvider, useFormik } from 'formik';
import { initCaseFormChange, setFormChanged } from 'app/shared/reducers/case-form-change';
import { Button } from 'edozvola-frontend-lib/dist/ui/components';
import CaseRevisionForm from 'app/edozvola/cases/case-revision/case-revision-form';
import CaseRevisionTable from 'app/edozvola/cases/case-revision/case-revision-table';
import { Alert, Col, Row } from 'reactstrap';
import { Label } from 'edozvola-frontend-lib/dist/ui';
import { PaginatedDropdown } from 'edozvola-frontend-lib/dist/ui/components/paginated-dropdown';
import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import {
  caseRevisionDataInitial,
  CaseRevisionsDataModel
} from 'app/edozvola/cases/case-revision/model/case-revision.model';
import { ToggleWithLabels } from 'edozvola-frontend-lib/dist/ui/components/toggle-with-labels';
import { caseRevisionDataValidationSchema } from 'app/edozvola/cases/case-revision/model/case-revision.schema';
import {
  getCaseRevisionDataQuery,
  saveCaseRevisionDataQuery
} from 'app/edozvola/cases/case-revision/service/case-revision.queries';
import { useParams } from 'react-router-dom';
import { fetchRevisionDeliveryOptionsQuery } from 'app/edozvola/codebooks/codebooks.queries';
import FormikValueObserver from 'app/shared/formik-observer/formik-observer';
import { getCaseContext } from 'app/shared/util/context-util';

const CaseRevision = () => {
  const { id: uuid } = useParams<{ id: string }>();
  const [idRevision, setIdRevision] = useState<string | null>(null);
  const [revisionReadOnly, setRevisionReadOnly] = useState<boolean>();

  const { sidebarItemPair } = getCaseContext();
  const dispatch = useDispatch();

  const { data: revisionDeliveryOptions, isLoading: revisionDeliveryOptionsLoading } = fetchRevisionDeliveryOptionsQuery();
  const { data: caseRevisionData, isLoading: caseRevisionDataLoading } = getCaseRevisionDataQuery(uuid);

  const formik = useFormik({
    initialValues: caseRevisionData || caseRevisionDataInitial,
    validationSchema: caseRevisionDataValidationSchema,
    enableReinitialize: true,
    validateOnMount: true,
    initialTouched: {
      explanation: true
    },
    onSubmit: (values: CaseRevisionsDataModel) => saveCaseRevisionData(values),
  });

  const {mutate: saveCaseRevisionData, isPending: savingCaseRevisionData} = saveCaseRevisionDataQuery(uuid)

  const openNewRevisionForm = () => {
    setIdRevision('');
    setRevisionReadOnly(false);
  };

  const reportsAttachedChanged = (event: any) => {
    formik.setValues({
      reportsAttached: event.target.checked,
      explanation: []
    })
  }

  return (
    <>
      <FormikProvider value={formik}>
        <FormikValueObserver
          onChange={dirty => {
            if (dirty.dirty) {
              dispatch(setFormChanged(true));
            } else {
              dispatch(initCaseFormChange());
            }
          }}
        />
        <Row>
          <Col md={3}>
            <Label labelText={'Priložena izvješća o kontroli glavnog projekta'} />
            <ToggleWithLabels
              trueLabel="DA"
              falseLabel="NE"
              checked={formik.values.reportsAttached}
              onChange={e => reportsAttachedChanged(e)}
              disabled={sidebarItemPair?.readOnly}
            />
          </Col>
        </Row>
        {formik.dirty && !caseRevisionData.reportsAttached && formik.values.reportsAttached && (
          <Row>
            <Col md={6}>
              <Alert color="warning">Potrebno je prvo spremiti obvezne podatke na kartici da biste mogli dodati revizije!</Alert>
            </Col>
          </Row>
        )}
        <hr />
        <div className={'form-header mb-3'}>Revizija glavnog projekta</div>
        <Col md={6}>
          <Label labelText={'Obrazloženje'} />
          <PaginatedDropdown
            placeholder={!(sidebarItemPair?.readOnly || !formik.values.reportsAttached) && 'Odaberi obrazloženje'}
            onItemSelect={value => formik.setFieldValue('explanation', value)}
            selected={formik.values.explanation}
            labelKey={'value'}
            options={revisionDeliveryOptionsLoading ? [] : revisionDeliveryOptions}
            disabled={sidebarItemPair?.readOnly || !formik.values.reportsAttached}
            error={(formik.errors.explanation as string) ?? ''}
            showErrorMessage
          />
        </Col>
        <div className={'d-flex justify-content-end pb-4 gap-2'}>
          {!sidebarItemPair?.readOnly && (
            <>
              <div className={'d-flex justify-content-end '}>
                <div>
                  <Button
                    label={'Dodaj reviziju'}
                    color={'info'}
                    prependIcon={'plus'}
                    size={'lg'}
                    onClick={openNewRevisionForm}
                    disabled={(formik.dirty && !caseRevisionData.reportsAttached && formik.values.reportsAttached) || !formik.values.reportsAttached}
                  />
                </div>
              </div>
            </>
          )}
        </div>
        {idRevision !== null && (
          <CaseRevisionForm readOnly={revisionReadOnly} setIdMainProjectRevision={setIdRevision} idMainProjectRevision={idRevision} />
        )}
        <CaseRevisionTable setReadOnly={setRevisionReadOnly} setMainProjectRevision={setIdRevision} editRevisionDisabled={(!caseRevisionData?.reportsAttached && formik.values.reportsAttached) || !formik.values.reportsAttached} />
        {!sidebarItemPair?.readOnly && (
          <div className={'case-save-button'}>
            <Button
              label={'Spremi'}
              size={'lg'}
              disabled={!formik.dirty || !formik.isValid}
              isLoading={savingCaseRevisionData}
              color={'info'}
              onClick={() => formik.handleSubmit()}
            />
          </div>
        )}
      </FormikProvider>
    </>
  );
};

export default CaseRevision
